export default function Hero() {
  return (
    <section
      id="hero"
      className="px-5 lg:px-10 w-full flex flex-col lg:flex-row gap-6 lg:gap-12 justify-center items-center mt-20 mb-16 max-w-5xl mx-auto h-[80vh] bg-orange-100"
    >
      <div className="flex-1 flex flex-col justify-center items-center gap-5">
        <h2 className="text-center text-orange-400 text-4xl lg:text-5xl font-bold">
          Welcome to Mela Software
        </h2>
        <h4 className="text-center text-lg lg:text-xl font-bold">
          Transforming Ideas into Innovative Solutions
        </h4>
        <a href="#contact" className="mt-5">
          <button className="bg-orange-500 text-white px-6 py-3 rounded-full hover:bg-orange-400 transition duration-300 font-bold">
            Contact Us
          </button>
        </a>
      </div>
      <div className="flex-1">
        <img 
          src="/assets/mela-logo.png" 
          alt="Mela Software Logo" 
          className="w-full h-auto object-contain max-w-xs lg:max-w-md" 
        />
      </div>
    </section>
  );
}